import { useLazyQuery } from '@apollo/client';

import { GET_ADVERTISEMENT_CONTACT } from 'schemas';

import { IUseGetAdvertisementContactReturn } from './interfaces';

export const useGetAdvertisementContact =
  (): IUseGetAdvertisementContactReturn => {
    const [getContact, { data, loading }] = useLazyQuery(
      GET_ADVERTISEMENT_CONTACT
    );

    const handledGetContact = async (id: string): Promise<string> => {
      const result = await getContact({
        variables: { id },
      });

      return result.data?.getAdvertisementContact ?? '';
    };

    return {
      handledGetContact,
      contact: data?.getAdvertisementContact ?? '',
      loading,
    };
  };
